<template>
    <Modal :title="activation.description || ''" width="push-40" section="showItemDialog">
        <div class="row mt-0 mb-4" v-if="is_loading">
            <div class="col-12">
                <ShowPageLoading></ShowPageLoading>
            </div>
        </div>
        <div class="row mt-4 mb-4 d-flex justify-content-between" v-else>
            <div class="col-md-5">
                <div class="mt-2 mb-2">
                    <h3>Activation Data</h3>

                    <ul v-for="(item, index) in activation.dataset" :key="item + index" v-if="activation.dataset" class="list-no-bullets-no-padding-left">
                        <li class="pb-3" v-if="index === 0 && activation.dataset.length === 1">
                            <span v-html="getActivationQueryValue(activation)"></span>
                        </li>

                        <li>Analysis Type: <strong>{{ item.analysistype }} </strong></li>

                        <li v-if="item.startDate">Start Date: <strong>{{ item.startDate || '' }} </strong></li>
                        <li v-if="item.endDate">End Date: <strong>{{ item.endDate || '' }} </strong></li>

                        <li v-if="item.cohort_name && item.analysistype === 'Cohorts'">Name: {{ item.cohort_name }}</li>

                        <li v-if="item.signalproviders.length"><span v-html="showHideValue('signal-providers', index)" class="toggle-button" @click="toggleShow('signal-providers', index)"></span> {{ item.signalproviders.length }} Signal Providers</li>
                        <ul v-if="item.signalproviders.length" :class="{'hide-toggle' : !showedData.includes('signal-providers_' + index)}">
                            <li v-for="(data, index) in item.signalproviders" :key="data + index"> {{ data }} </li>
                        </ul>

                        <li v-if="item.categories.length"><span v-html="showHideValue('categories', index)" class="toggle-button" @click="toggleShow('categories', index)"></span> {{ item.categories.length }} Categories</li>
                        <ul v-if="item.categories.length" :class="{'hide-toggle' : !showedData.includes('categories_' + index)}">
                            <li v-for="item in item.categories"> {{ item }} </li>
                        </ul>

                        <li v-if="item.analysisdata.length"><span v-html="showHideValue('analysisdata', index)" class="toggle-button" @click="toggleShow('analysisdata', index)"></span> {{ item.analysisdata.length }} Brands</li>
                        <ul v-if="item.analysisdata.length" :class="{'hide-toggle' : !showedData.includes('analysisdata_' + index)}">
                            <li v-for="item in item.analysisdata"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_categories.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_categories', index)" class="toggle-button" @click="toggleShow('apps_categories', index)"></span> {{ item.apps_categories.length }} Categories</li>
                        <ul v-if="item.apps_categories.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_categories_' + index)}">
                            <li v-for="item in item.apps_categories"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_tags.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_tags', index)" class="toggle-button" @click="toggleShow('apps_tags', index)"></span> {{ item.apps_tags.length }} Tags</li>
                        <ul v-if="item.apps_tags.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_tags_' + index)}">
                            <li v-for="item in item.apps_tags"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_bundle_ids.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_bundle_ids', index)" class="toggle-button" @click="toggleShow('apps_bundle_ids', index)"></span> {{ item.apps_bundle_ids.length }} App Names</li>
                        <ul v-if="item.apps_bundle_ids.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_bundle_ids_' + index)}">
                            <li v-for="item in item.apps_bundle_ids"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_device_os.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_device_os', index)" class="toggle-button" @click="toggleShow('apps_device_os', index)"></span> {{ item.apps_device_os.length }} Device OS</li>
                        <ul v-if="item.apps_device_os.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_device_os_' + index)}">
                            <li v-for="item in item.apps_device_os"> {{ item }} </li>
                        </ul>

                        <li v-if="item.countries.length && ['POI', 'Anonymized', 'Apps'].includes(item.analysistype)"><span v-html="showHideValue('countries', index)" class="toggle-button" @click="toggleShow('countries', index)"></span> {{ item.countries.length }} Countries</li>
                        <ul v-if="item.countries.length && ['POI', 'Anonymized', 'Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('countries_' + index)}">
                            <li v-for="item in item.countries"> {{ item }} </li>
                        </ul>

                        <li v-if="item.states.length"><span v-html="showHideValue('states', index)" class="toggle-button" @click="toggleShow('states', index)"></span> {{ item.states.length }} States</li>
                        <ul v-if="item.states.length" :class="{'hide-toggle' : !showedData.includes('states_' + index)}">
                            <li v-for="item in item.states"> {{ item }} </li>
                        </ul>

                        <li v-if="item.dmas.length"><span v-html="showHideValue('dmas', index)" class="toggle-button" @click="toggleShow('dmas', index)"></span> {{ item.dmas.length }} DMAs</li>
                        <ul v-if="item.dmas.length" :class="{'hide-toggle' : !showedData.includes('dmas_' + index)}">
                            <li v-for="item in item.dmas"> {{ item }} </li>
                        </ul>

                        <li v-if="item.cities.length"><span v-html="showHideValue('cities', index)" class="toggle-button" @click="toggleShow('cities', index)"></span> {{ item.cities.length }} Cities</li>
                        <ul v-if="item.cities.length" :class="{'hide-toggle' : !showedData.includes('cities_' + index)}">
                            <li v-for="item in item.cities"> {{ item }} </li>
                        </ul>

                        <li v-if="item.zipcodes.length"><span v-html="showHideValue('zipcodes', index)" class="toggle-button" @click="toggleShow('zipcodes', index)"></span> {{ item.zipcodes.length }} Zip Codes</li>
                        <ul v-if="item.zipcodes.length" :class="{'hide-toggle' : !showedData.includes('zipcodes_' + index)}">
                            <li v-for="item in item.zipcodes"> {{ item }} </li>
                        </ul>

                        <li class="mt-3" v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields"><strong>Selected Fields:</strong></li>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.geoLocation">
                            <span v-html="showHideValue('geo', index)" class="toggle-button" @click="toggleShow('geo', index)"></span>
                            {{ item.selectedFields.geoLocation.length }} Geo Location
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.geoLocation" :class="{'hide-toggle' : !showedData.includes('geo_' + index)}">
                            <li v-for="item in item.selectedFields.geoLocation"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.Advertising">
                            <span v-html="showHideValue('advertising', index)" class="toggle-button" @click="toggleShow('advertising', index)"></span>
                            {{ item.selectedFields.Advertising.length }} Advertising
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.Advertising" :class="{'hide-toggle' : !showedData.includes('advertising_' + index)}">
                            <li v-for="item in item.selectedFields.Advertising"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.userDetails">
                            <span v-html="showHideValue('user_details', index)" class="toggle-button" @click="toggleShow('user_details', index)"></span>
                            {{ item.selectedFields.userDetails.length }} User Details
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.userDetails" :class="{'hide-toggle' : !showedData.includes('user_details_' + index)}">
                            <li v-for="item in item.selectedFields.userDetails"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.ipDetails">
                            <span v-html="showHideValue('ip_details', index)" class="toggle-button" @click="toggleShow('ip_details', index)"></span>
                            {{ item.selectedFields.ipDetails.length }} IP Details
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.ipDetails" :class="{'hide-toggle' : !showedData.includes('ip_details_' + index)}">
                            <li v-for="item in item.selectedFields.ipDetails"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.privacy">
                            <span v-html="showHideValue('privacy', index)" class="toggle-button" @click="toggleShow('privacy', index)"></span>
                            {{ item.selectedFields.privacy.length }} Privacy
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.privacy" :class="{'hide-toggle' : !showedData.includes('privacy_' + index)}">
                            <li v-for="item in item.selectedFields.privacy"> {{ item }} </li>
                        </ul>

                        <li class="mt-3" v-if="index === 0 && activation.dataset.length > 1">
                            <span v-html="getActivationQueryValue(activation)"></span>
                        </li>
                    </ul>

                    <ul v-if="activation.dataset && Object.keys(activation.dataset[0].competitors).length !== 0" class="list-no-bullets-no-padding-left">
                        <li><strong>Competitors: </strong></li>
                        <li v-if="activation.dataset[0].competitors.distance">Distance: <strong>up to{{ activation.dataset[0].competitors.distance + ' ' + activation.dataset[0].competitors.unit  }} </strong></li>

                        <li v-if="activation.dataset[0].competitors.categories.length"><span v-html="showHideValue('categories', 'comp')" class="toggle-button" @click="toggleShow('categories', 'comp')"></span> {{ activation.dataset[0].competitors.categories.length }} Categories</li>
                        <ul v-if="activation.dataset[0].competitors.categories.length" :class="{'hide-toggle' : !showedData.includes('categories_comp')}">
                            <li v-for="item in activation.dataset[0].competitors.categories"> {{ item }} </li>
                        </ul>

                        <li v-if="activation.dataset[0].competitors.analysisdata.length"><span v-html="showHideValue('analysisdata', 'comp')" class="toggle-button" @click="toggleShow('analysisdata', 'comp')"></span> {{ activation.dataset[0].competitors.analysisdata.length }} Brands</li>
                        <ul v-if="activation.dataset[0].competitors.analysisdata.length" :class="{'hide-toggle' : !showedData.includes('analysisdata_comp')}">
                            <li v-for="item in activation.dataset[0].competitors.analysisdata"> {{ item }} </li>
                        </ul>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="mt-2 mb-4">
                    <h3>Delivery Details</h3>
                    <div class="row mt-3 mb-2" v-if="activation.endpoint">
                        <div class="form-inline col-md-4 py-0"><strong> Endpoint: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ activation.endpoint.partner_name || 'Default' }} </div>
                    </div>

                    <div class="row mt-2 mb-2" v-for="(endpoint, index) in activation.endpoint" v-if="(index !== 'partner_name' && !['datastreams', 'account_credentials', 'pricing_model_id'].includes(index))">
                        <div class="form-inline col-md-4 py-0"><strong style="text-transform: capitalize;">{{ index.replace('_', ' ') }}: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ endpoint }} </div>
                    </div>

                    <div v-if="activation.credentials">
                        <i class="fas fa-file orange-color"></i>
                        <span class="ml-1">Credentials file attached</span>
                    </div>

                    <div class="row mt-3 mb-2" v-if="activation.compression">
                        <div class="form-inline col-md-4 py-0"><strong> Data Format: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ activation.compression === 'csv' ? 'CSV Uncompressed' : 'GZIP Compression' }} </div>
                    </div>
                </div>
                <div class="mt-4 mb-2">
                    <h3>Activation Details</h3>

                    <div class="row mt-3 mb-2">
                        <div class="form-inline col-md-4 py-0"><strong> Activation Name: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ activation.description || '' }} </div>
                    </div>
                    <div v-if="activation.isCompleted && (activation.result_link.uri && activation.result_link.url)" class="row mt-2 mb-2">
                        <div class="form-inline col-md-4 py-0"><strong> Results: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <ResultsUrl :uri="activation.result_link.uri" :url="activation.result_link.url"></ResultsUrl>
                        </div>
                    </div>

                    <div class="row mt-2 mb-2">
                        <div class="form-inline col-md-4 py-0" v-if="activation.endpoint"><strong> Limit {{ getIdentifierByPricingModel(activation.endpoint.pricing_model) }}s: </strong> </div>
                        <div class="form-inline col-md-8 py-0" v-if="activation.limit"> {{ new Intl.NumberFormat().format(activation.limit) }} </div>
                        <div class="form-inline col-md-8 py-0 font-italic" v-else> Unlimited </div>
                    </div>

                    <div class="row mt-2 mb-2" v-if="activation.isDecrypted">
                        <div class="form-inline col-md-4 py-0"><strong> Decrypted: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">  {{ new Intl.NumberFormat().format(activation.totalDecrypted) || '' }} ({{  new Intl.NumberFormat("en", {maximumFractionDigits: 2}).format(parseInt(activation.totalDecrypted)/parseInt(activation.limit)*100) }}%) </span>
                                </template>
                                <span> Total Decrypted EIDs from Signal Providers</span>
                            </v-tooltip>
                        </div>
                    </div>

                    <div class="row mt-2 mb-2" v-if="activation.isMapped">
                        <div class="form-inline col-md-4 py-0"><strong> IPs Mapped: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">  {{ new Intl.NumberFormat().format(activation.totalMapped) || '' }} ({{  new Intl.NumberFormat("en", {maximumFractionDigits: 2}).format(parseInt(activation.totalMapped)/parseInt(activation.limit)*100) }}%) </span>
                                </template>
                                <span> Total Mapped EIDs as IPs from Signal Providers</span>
                            </v-tooltip>
                        </div>
                    </div>

                    <div class="row mt-2 mb-2" v-if="activation.eids">
                        <div class="form-inline col-md-4 py-0"><strong> Total Costs: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            ${{ new Intl.NumberFormat().format(activation.eids * activation.costs) || '' }}
                            <v-tooltip top v-if="activation.eids && activation.endpoint">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" small class="ml-1 text-info">
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>
                                    {{ new Intl.NumberFormat().format(activation.eids) }} {{ getIdentifierByPricingModel(activation.endpoint.pricing_model) }}s * ${{ activation.costs }} = ${{ new Intl.NumberFormat().format(activation.eids * activation.costs) }} <br />
                                    {{ activation.endpoint.pricing_model }}
                                </span>
                            </v-tooltip>
                        </div>
                    </div>

                    <div class="row mt-3 mb-2" v-if="activation.dataStreams && activation.dataStreams.length">
                        <div class="form-inline col-md-4 py-0"><strong> DataStreams: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <ul class="mb-0" style="list-style:none;padding-left:0;">
                                <li v-for="(dataStream, index) in activation.dataStreams">
                                    {{ dataStream || '' }}
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div class="mt-4 mb-2" v-if="activation.ds_results && activation.ds_results.length">
                    <h3>DataStreams Results</h3>
                    <div class="row mt-3 mb-2" v-for="ds in activation.ds_results">
                        <div class="form-inline col-md-4 py-0"><strong class="text-capitalize"> {{  ds.name.replaceAll("_"," ") }}: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <template v-if="ds.file">
                                <ResultsUrl :uri="ds.file.uri" :url="ds.file.url"></ResultsUrl>
                            </template>
                            <template v-else>
                                <span class="text-danger">
                                    <i class="fas fa-exclamation-circle mr-1"></i>
                                    Not Available
                                </span>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="mt-4 mb-2" v-if="activation.startDate || activation.endDate || (activation.freq_limit && (activation.minfreq || activation.maxfreq))">
                    <h3>Activation Recency</h3>

                    <div class="row mt-3 mb-2" v-if="activation.startDate">
                        <div class="form-inline col-md-3 py-0"><strong> Start Date: </strong> </div>
                        <div class="form-inline col-md-9 py-0"> {{ activation.startDate || '' }} </div>
                    </div>
                    <div class="row mt-2 mb-2" v-if="activation.endDate">
                        <div class="form-inline col-md-3 py-0"><strong> End Date:  </strong> </div>
                        <div class="form-inline col-md-9 py-0">  {{ activation.endDate || '' }} </div>
                    </div>
                    <div class="row mt-2 mb-2" v-if="activation.minfreq">
                        <div class="form-inline col-md-3 py-0"><strong> Min. {{ getFreqLimitsStringByLimitType(activation.freq_type) }} </strong> </div>
                        <div class="form-inline col-md-9 py-0">  {{ getFreqLimitsValuesByLimitType(activation.freq_type, activation.minfreq, 'min') || '' }}  </div>
                    </div>
                    <div class="row mt-2 mb-2" v-if="activation.maxfreq">
                        <div class="form-inline col-md-3 py-0"><strong> Max. {{ getFreqLimitsStringByLimitType(activation.freq_type) }} </strong> </div>
                        <div class="form-inline col-md-9 py-0">  {{ getFreqLimitsValuesByLimitType(activation.freq_type, activation.maxfreq, 'max') || '' }}  </div>
                    </div>
                </div>

                <div class="mt-4 mb-2">
                    <h3>Activation Properties</h3>
                    <div class="row mt-2 mb-2">
                        <div class="form-inline col-md-3 py-0"><strong> Status: </strong> </div>
                        <div class="form-inline col-md-4 py-0">
                            <v-progress-linear
                                v-if="!activation.isCompleted && activation.status && !activation.status.isError"
                                color="#fb7e42"
                                height="10"
                                indeterminate
                                rounded
                            ></v-progress-linear>

                            <v-progress-linear
                                v-if="activation.isCompleted"
                                color="success"
                                height="10"
                                value="100"
                                rounded
                            ></v-progress-linear>
                            <span :class="(activation.status && activation.status.isError) ? 'text-danger' : ''">
                                {{ activation.status ? activation.status.string : '' }}

                                <v-tooltip top v-if="!activation.isCompleted && (activation.status && activation.status.message)" :color="(activation.status && activation.status.isError) ? 'error' : ''">
                                    <template v-slot:activator="{ on, attrs }">
                                        <i v-bind="attrs" v-on="on" class="fas fa-info-circle" :class="(activation.status && activation.status.isError) ? 'text-danger' : 'text-info'"></i>
                                    </template>
                                    <span>
                                        {{ activation.status ? activation.status.message : '' }}
                                    </span>
                                </v-tooltip>
                            </span>
                        </div>
                    </div>

                    <div v-if="activation.audienceInfo" class="row mt-2 mb-2">
                        <div class="form-inline col-md-3 py-0"><strong> Base Audience: </strong> </div>
                        <div class="form-inline col-md-9 py-0">
                            <a :href="activation.audienceInfo.uri || '#'" style="color: ${primaryColor}; max-width: 25rem;" >{{ activation.audienceInfo.name }}</a>
                        </div>
                    </div>

                    <div class="row mt-2 mb-2">
                        <div class="form-inline col-md-3 py-0"><strong> Created at: </strong> </div>
                        <div class="form-inline col-md-9 py-0">{{ activation.created_at || '' }} </div>
                    </div>
                    <div class="row mt-2 mb-2">
                        <div class="form-inline col-md-3 py-0"><strong> Updated at: </strong> </div>
                        <div class="form-inline col-md-9 py-0">{{ activation.updated_at || '' }} </div>
                    </div>
                    <div class="row mt-2 mb-2">
                        <div class="form-inline col-md-3 py-0"><strong> Created by: </strong> </div>
                        <div class="form-inline col-md-9 py-0"> {{ activation.user_id || '' }} </div>
                    </div>
                </div>
            </div>
            <!--form-group-->
        </div>
    </Modal>
</template>

<script>
import Modal from '../Modal'
import mixins from "../../mixin";
import api from "../../api/analyses/activations";
import ResultsUrl from "./partials/shared/ResultsUrl.vue";
import ShowPageLoading from "../general/ShowPageLoading.vue";
export default {
    name: "ShowActivationItem",
    mixins: [mixins],
    data: () => ({
        showedData: [],
        activation: [],
        is_loading: true,
    }),
    components: {
        ShowPageLoading,
        ResultsUrl,
        Modal
    },
    methods: {
        async fetchActivation() {
            await api.getSingleActivation({
                _token: $('meta[name="_token"]').attr('content'),
                activation: this.$parent.activation
            })
                .then(res => {
                    if (res.status === 202) {
                        this.$toast.open({
                            message: 'This activation item was removed.',
                            type: "error",
                        })
                        this.$parent.showItemDialog = false
                        this.$parent.showingAudience = ''
                        window.history.pushState({}, null, window.location.href.split('/').splice(0, 6).join('/'));
                    }

                    this.activation = res.data
                    this.is_loading = false
                })
                .catch(e => {
                    this.$toast.open({
                        message: e.response.data.message,
                        type: "error",
                    })
                    this.$parent.showingAudience = null
                    this.$parent.showItemDialog = false
                })
        },
        getFreqLimitsStringByLimitType(type) {
            let freq_string = 'Frequency'

            if (type === 'DayPart') {
                freq_string = 'Day Part Freq.'
            }

            return freq_string
        },
        getFreqLimitsValuesByLimitType(type, value, period) {
            let freq_value = value

            if (type === 'DayPart') {
                let final_string = ''
                if (value.toString().length == 1) {
                    final_string = "0" + value
                } else {
                    final_string = value
                }

                if (period === 'min') {
                    freq_value = final_string + ':00'
                }

                if (period === 'max') {
                    freq_value = final_string + ':59'
                }

            }

            return freq_value
        }

    },
    created() {
        this.fetchActivation()
    }
}
</script>

<style scoped lang="scss">
h3 {
    border-bottom: 1px solid #ff7516;
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 32px;
    padding: 0 12px;
}
</style>